function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var Loader = /*#__PURE__*/function () {
  function Loader() {
    var apiKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Loader);

    this.apiKey = apiKey;
    this.options = options;

    if (typeof window === 'undefined') {
      throw new Error('google-maps is supported only in browser environment');
    }
  }

  _createClass(Loader, [{
    key: "load",
    value: function load() {
      var _this = this;

      if (typeof this.api !== 'undefined') {
        return Promise.resolve(this.api);
      }

      if (typeof this.loader !== 'undefined') {
        return this.loader;
      }

      window[Loader.CALLBACK_NAME] = function () {
        _this.api = window['google'];

        if (typeof _this.resolve === 'undefined') {
          throw new Error('Should not happen');
        }

        _this.resolve(_this.api);
      };

      window['gm_authFailure'] = function () {
        if (typeof _this.reject === 'undefined') {
          throw new Error('Should not happen');
        }

        _this.reject(new Error('google-maps: authentication error'));
      };

      return this.loader = new Promise(function (resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
        var script = document.createElement('script');
        script.src = _this.createUrl();
        script.async = true;

        script.onerror = function (e) {
          return reject(e);
        };

        document.head.appendChild(script);
      });
    }
  }, {
    key: "createUrl",
    value: function createUrl() {
      var parameters = ["callback=".concat(Loader.CALLBACK_NAME)];

      if (this.apiKey) {
        parameters.push("key=".concat(this.apiKey));
      }

      for (var name in this.options) {
        if (this.options.hasOwnProperty(name)) {
          var value = this.options[name];

          if (name === 'version') {
            name = 'v';
          }

          if (name === 'libraries') {
            value = value.join(',');
          }

          parameters.push("".concat(name, "=").concat(value));
        }
      }

      return "//maps.googleapis.com/maps/api/js?".concat(parameters.join('&'));
    }
  }]);

  return Loader;
}();
Loader.CALLBACK_NAME = '_dk_google_maps_loader_cb';